"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var colors_1 = require("../colors");
var MuiInputBase = {
  styleOverrides: {
    root: {
      input: {
        height: 'auto'
      },
      '&.Mui-error .MuiInputAdornment-positionStart svg path': {
        fill: colors_1.colors.NotificacionesRojo,
        backgroundColor: 'rgb(40,40,40)!important'
      }
    }
  }
};
exports.default = {
  MuiInputBase: MuiInputBase
};